// export const msalConfig = {
//   auth: {
//     clientId: "8c060e43-3511-4b0d-bdb5-88506fa1bb63",              // Copy from Azure
//     authority: "https://login.microsoftonline.com/5f27b256-accb-43ef-a927-37cd0aac4d10", // Replace with your Tenant ID
//     redirectUri: "https://fibrebondmis.com", 
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: false,
//   },
// };

// export const loginRequest = {
//   scopes: ["openid", "profile", "email"],
// };


const isLocalhost = window.location.hostname === 'localhost';

export const msalConfig = {
  auth: {
    clientId: "5f27b256-accb-43ef-a927-37cd0aac4d10",
    authority: "https://login.microsoftonline.com/8c060e43-3511-4b0d-bdb5-88506fa1bb63",
    redirectUri: isLocalhost
      ? "http://localhost:3000" // ✔ for local testing
      : "https://fibrebondmis.com/auth", // ✅ MUST end in /auth
    //   : "https://fibrebondmis.com/auth",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
